import { ReportHandler } from 'web-vitals';
import { datadogRum } from '@datadog/browser-rum';
import { datadogConfig } from './config';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

// Initialize Datadog Monitoring
datadogRum.init(datadogConfig);
datadogRum.startSessionReplayRecording();

export default reportWebVitals;
